import React, { useState, useRef, useEffect} from 'react'
import NavbarReturn from '../components/NavbarReturn';
import { Toaster } from 'react-hot-toast';
import FooterAdmin from "../components/FooterAdmin";
import SearchBar from "../components/SearchBar";
import AlertBox from '../components/AlertBox';
import {createUserWithEmailAndPassword, deleteUser, signOut} from 'firebase/auth';
import { collection, addDoc, getDocs, doc, deleteDoc, setDoc, updateDoc, query, where } from "firebase/firestore";
import { auth, database, secondaryAuth } from "../config/firebaseConfig";
import AlertOnLoading from '../components/AlertOnLoading';
import {XMarkIcon} from '@heroicons/react/24/outline';

function ManageAdmins() {

    const SUCCESS = "success";
    const WARNING = "warning";
    const DANGER = "danger";

    const WAIT_TIME = 500; //Waits for 0.5s
    const notInitialRender = useRef(false);

    const [adminEmail, setAdminEmail] = useState("");
    const [adminFirstName, setAdminFirstName] = useState("");
    const [adminLastName, setAdminLastName] = useState("");
    const [adminPassword, setAdminPassword] = useState("");
    
    const [admins, setAdmins] = useState(null);
    const [newDataAdmins, setNewDataAdmins] = useState(true);

    const getMaxProducts = (width) => {
        if (width>= 640) {
          return 10;
        }
    
        return 5;
      }

    const [currentPage, setCurrentPage] = useState(1);
    const [adminsPerPages, setAdminsPerPages] = useState(getMaxProducts(window.innerWidth));

    
    const lastAdminIndex = currentPage * adminsPerPages;
    const firstAdminIndex = lastAdminIndex - adminsPerPages;

    async function addAdmin() {
      try{
        createUserWithEmailAndPassword(secondaryAuth, adminEmail, adminPassword).then(function(firebaseUser) {
          console.log("User " + firebaseUser.user.uid + " created successfully!");

          if (firebaseUser) {
            const adminRef = doc(database, `users/${firebaseUser.user.uid}`);
            setDoc(adminRef, {name:adminFirstName.trim(), lastname:adminLastName.trim(), email: adminEmail.trim(), role:"admin"}).then(
              () => {
                setAdminEmail("");
                setAdminFirstName("");
                setAdminLastName("");
                setAdminPassword("");
                setNewDataAdmins(true);
                AlertBox(SUCCESS, '¡Admin creado con éxito!');
                signOut(secondaryAuth);
                console.log("Cierro Sesión");
              }
            );
          }
        });

        
    } catch (e) {
        console.log(e.message);
        switch(e.message) {
            case "Firebase: Error (auth/invalid-email).":
                AlertBox(WARNING, '¡Debe ingresar un correo electrónico válido!')
                break;
            case "Firebase: Password should be at least 6 characters (auth/weak-password).":
                AlertBox(WARNING, '¡Debe ingresar una contraseña válida (6 carácteres de largo)!')
                break;
            case "Firebase: Error (auth/email-already-in-use).":
                AlertBox(WARNING, '¡El correo electrónico ya se encuentra en uso, trate de iniciar sesión!')
                break;
            default:
                AlertBox(WARNING, '¡Error desconocido mientras se creaba su cuenta!')
                break;
        } 
    }
    }

    const togglePopupDelete = (adminId) => {
        [].forEach.bind(document.getElementsByClassName(`popup_delete ${adminId}`),function(itm){
          itm.style.display = "flex";
        })();
      }

      const closePopupDelete = (adminId) => {
        [].forEach.bind(document.getElementsByClassName(`popup_delete ${adminId}`),function(itm){
          itm.style.display = "none";
        })();
      }

      const deleteAdmin = async (id) => {
        console.log(auth.currentUser);
  
        closePopupDelete(id);
      }

      useEffect(() => {
          if (notInitialRender.current && newDataAdmins){
              
          }else {
              notInitialRender.current = true;
          }
          const interval = setInterval(() => { //Autorize re-render
              if (newDataAdmins) {
                  const adminQuery = query(collection(database, "users"), where("role", "==", "admin"));
                  
                  const getAdmins = async() => {
                      const data = await getDocs(adminQuery);
                      setAdmins(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
                  }
                  getAdmins();
                  setNewDataAdmins(!newDataAdmins);
                  }
              }, WAIT_TIME);
              return () => clearInterval(interval);
      }, [admins, newDataAdmins])

  const resizeProducts = () => {
    setAdminsPerPages(getMaxProducts(window.innerWidth));
    return;
    }

  return (
    <div>

        <div>
            <Toaster
            toastOptions={{
                duration:3000,
            }}/>

        </div>

        <NavbarReturn />
        <div className='w-full h-navbar-mobile sm:h-navbar'></div>

        <div className='px-4 flex flex-col w-full h-full bg-white'>
            <h2 className='lg:text-xl mt-10'>Administradores</h2>
            <span className='lg:w-80 w-48 border border-primary-100'></span>
        </div>

        <div className='px-4 py-0 w-full h-auto flex flex-row bg-white'>

            <div className='flex flex-col space-y-4 px-4 py-6'>

                <div>
                    <input onChange={(event) => {setAdminEmail(event.target.value)}} value={adminEmail} type={"text"} placeholder="Correo"
                        className='text-sm md:text-base w-64 md:w-72 lg:w-input-web h-input-height py-2 px-3 text-input-font bg-primary-300
                        focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>
                </div>

                <div>
                    <input onChange={(event) => {setAdminFirstName(event.target.value)}} value={adminFirstName} type={"text"} placeholder="Nombre"
                        className='text-sm md:text-base w-64 md:w-72 lg:w-input-web h-input-height py-2 px-3 text-input-font bg-primary-300
                        focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>
                </div>

                <div>
                    <input onChange={(event) => {setAdminLastName(event.target.value)}} value={adminLastName} type={"text"} placeholder="Apellido"
                        className='text-sm md:text-base w-64 md:w-72 lg:w-input-web h-input-height py-2 px-3 text-input-font bg-primary-300
                        focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>
                </div>

                <div>
                    <input onChange={(event) => {setAdminPassword(event.target.value)}} value={adminPassword} type={"text"} placeholder="Contraseña"
                        className='text-sm md:text-base w-64 md:w-72 lg:w-input-web h-input-height py-2 px-3 text-input-font bg-primary-300
                        focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>
                </div>


                <div>
                    <button className='h-8 w-64 md:w-72 lg:w-input-web text-sm sm:text-base sm:h-9 bg-primary-100 mt-0 text-white rounded font-bold form1:text-xl hover:bg-primary-200'
                    onClick={addAdmin}>Agregar</button>
                </div>

            </div>

        </div>
        
        <div className='bg-white'>
        <div className='px-4 flex flex-col w-full h-full bg-white'>
            <h2 className='lg:text-xl mt-10'>Todos los administradores</h2>
            <span className=' lg:w-80 w-64 border border-primary-100'></span>
        </div>
          
          <div className="sm:flex sm:flex-col sm:px-10 sm:w-full sm:justify-center sm:items-center mt-5 bg-white">
            <div className={`sm:flex sm:flex-col sm:w-full sm:space-y-1 sm:justify-center ${admins? "sm:border sm:border-primary-100":"border-none"} p-1 sm:max-w-table-web`}>
                
                <div className={`${admins? "hidden w-full  sm:flex flex-row space-x-1": "hidden"}`}>

                  <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                    <h3 className={`text-sm text-primary-100 lg:text-xl form1:text-xl`}>Nombre</h3>
                  </div>

                  <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                    <h3 className={`text-sm text-primary-100 lg:text-xl form1:text-xl`}>Apellido</h3>
                  </div>


                  <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                    <h3 className={`text-sm text-primary-100 lg:text-xl form1:text-xl`}>Acción</h3>
                  </div>
                </div>
            {admins? admins.slice(firstAdminIndex, lastAdminIndex).map((admin, index)=> (
              <div className={"block"} key={index}>
                <div className="hidden w-full sm:flex flex-row space-x-1">

                  <div className="flex justify-center items-center w-full h-8 bg-background">
                    <h3 className="text-sm text-navFont-100 md:text-sm lg:text-xl form1:text-xl">{admin.name}</h3>
                  </div>


                  <div className="flex justify-center items-center w-full h-8 bg-background">
                    <h3 className="text-sm text-navFont-100 lg:text-xl form1:text-xl">{admin.lastname}</h3>
                  </div>

                  <div className="flex justify-center items-center w-full h-8 bg-background">
                    <div className='w-1/2 h-9 flex justify-center items-center'>
                      <button onClick={() => {togglePopupDelete(admin.id);}}
                      className='w-full h-7 text-sm bg-danger text-white rounded-md font-bold lg:text-sm form1:text-xl hover:bg-red-400'>Eliminar</button>
                    </div>
                  </div>
                </div>

                <div className="w-full mb-4 flex justify-center sm:hidden sm:w-auto sm:flex-col sm:border sm:border-primary-100 sm:max-w-table-web sm:justify-center form1:mx-80 lg:justify-center lg:mx-56 lg:max-w-table-web">
                  <div className="flex flex-col space-y-1 border border-primary-100 p-1 justify-center w-4/5 h-auto sm:flex-row sm:space-y-0 sm:space-x-1 sm:w-full max-w-table-web sm:border-none">

                    <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                      <h3 className="text-sm text-primary-100">Nombre</h3>
                    </div>

                    <div className="flex justify-center items-center w-full h-8 bg-background sm:hidden">
                      <h3 className="text-sm text-navFont-100">{admin.name}</h3>
                    </div>

                    <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                      <h3 className="text-sm text-primary-100">Apellido</h3>
                    </div>

                    <div className="flex justify-center items-center w-full h-8 bg-background sm:hidden">
                      <h3 className="text-sm text-navFont-100">{admin.lastname}</h3>
                    </div>

                    <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                      <h3 className="text-sm text-primary-100">Acción</h3>
                    </div>

                    <div className='w-full h-8 flex justify-center items-center bg-background sm:hidden'>
                      <div className='w-full h-9 flex justify-center items-center'>
                        <button onClick={() => {togglePopupDelete(admin.id);}} 
                        className='w-1/2 h-7 text-sm bg-danger text-white rounded-md font-bold hover:bg-red-400'>Eliminar</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`hidden relative z-40 popup_delete ${admin.id}`} aria-labelledby="modal-title" role="dialog" aria-modal="true" >
                  <div className="fixed inset-0 bg-popup"></div>

                  <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                      <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                          <div className="sm:flex sm:items-start">
                            <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                              <svg className="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v3.75m-9.303 3.376C1.83 19.126 2.914 21 4.645 21h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 4.88c-.866-1.501-3.032-1.501-3.898 0L2.697 17.626zM12 17.25h.007v.008H12v-.008z" />
                              </svg>
                            </div>
                            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                              <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">Eliminar Registro</h3>
                              <div className="mt-2">
                                <p className="text-sm text-gray-500">¿Está seguro que desea eliminar este registro? Este registro no se podrá recuperar. </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                          <button onClick={() => {deleteAdmin(admin.id);}} type="button" className="inline-flex w-full justify-center rounded-md border border-transparent bg-danger px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-400 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm">Eliminar</button>
                          <button onClick={() => {closePopupDelete(admin.id);}} type="button" className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">Cancelar</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
            :
            <div className='w-full flex h-footer-height justify-center items-center text-4xl text-primary-100 space-x-1'>
                <svg fill='none' className="w-14 h-14 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                    <path clipRule='evenodd'
                        d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                        fill='currentColor' fillRule='evenodd' />
                </svg>
                <div>
                    Cargando...
                </div>
            </div>
            }
            </div>

            <div className={`${admins? "flex" : "hidden"} w-full items-center justify-evenly mt-5`}>
                <span className={`text-sm text-gray-700`}>
                    Mostrando <span className="font-semibold text-gray-900">{lastAdminIndex >= admins?.length? admins?.length:lastAdminIndex}</span> de <span className="font-semibold text-gray-900">{admins?.length}</span> resultados
                </span>
                <div className="inline-flex mt-2 xs:mt-0">
                    <button
                        onClick={() => {setCurrentPage(currentPage - 1)}} 
                        className={`${currentPage === 1? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium rounded-l`}>
                        Anterior
                    </button>
                    <button 
                        onClick={() => {setCurrentPage(currentPage + 1)}}
                        
                        className={`${lastAdminIndex >= admins?.length? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium border-0 border-l border-white rounded-r`}>
                        Siguiente
                    </button>
                </div>
            </div>
          </div>
          </div>

    </div>
  )
}

export default ManageAdmins